import {isNotNilOrEmpty} from 'ramda-adjunct';

import {
  GetDirectSaleVariantDefaultVarehousesPriorityResponse,
  GetDirectSaleVariantResponse,
} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

// A new variant starts from the tenant-wide default priority list; an existing one keeps its own.
export function buildWarehousesPriorityDefaultValues(
  directSaleVariantId: string | Nullish,
  warehousesPriority: GetDirectSaleVariantResponse['warehousesPriority'] | Nullish,
  // Undefined while the default priority list is still loading.
  defaultWarehousesPriority: GetDirectSaleVariantDefaultVarehousesPriorityResponse | undefined
) {
  return isNotNilOrEmpty(directSaleVariantId)
    ? (warehousesPriority ?? [])
    : defaultWarehousesPriority;
}
